/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Image,
  Input,
  Message,
  Modal,
  Space,
  Table,
  TableColumnProps,
  Typography,
  Upload
} from '@arco-design/web-react';
import dayjs from 'dayjs';

import './index.scss';

import { API_CONFIG } from '../utils';
import { get, post } from '../requestNew';
import { Item, UploadImage } from './types';

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function Composition() {
  const [form] = Form.useForm<Item>();
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [pageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);
  const [defaultFileList, setDefaultFileList] = useState<UploadImage[]>([]);
  const [picture, setPicture] = useState<string[]>([]);
  const [videoSrc, setSrc] = useState<string>('');
  const [videoVisible, setVideoVisible] = useState<boolean>(false);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '标题',
      dataIndex: 'title',
      width: 120
    },
    {
      title: '内容',
      dataIndex: 'content',
      width: 300
    },
    {
      title: '图片',
      dataIndex: 'picture',
      width: 260,
      render: arr => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {arr.map((src: string) => {
              if ((src || '').toLocaleLowerCase().endsWith('.mp4')) {
                return (
                  <video
                    onClick={() => play(src)}
                    style={{ marginRight: 8 }}
                    key={src}
                    width={50}
                    height={50}
                    src={src}
                    controls={false}
                  />
                );
              } else {
                return <Image style={{ marginRight: 8 }} key={src} width={50} height={50} src={src} alt="" />;
              }
            })}
          </div>
        );
      }
    },
    {
      title: '发布时间',
      dataIndex: 'createTime',
      width: 130,
      render: text => dayjs(text).format('YYYY-MM-DD')
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
          <Button className="btn" type="text" onClick={() => del(record)}>
            删除
          </Button>
        </>
      )
    }
  ];

  const play = (url: string) => {
    setSrc(url);
    setVideoVisible(true);
  };
  const videoCancel = () => {
    setSrc('');
    setVideoVisible(false);
  };

  const titleChange = (val: string) => {
    setTitle(val);
  };

  const handleReset = () => {
    setTitle('');
    setPageNum(1);
    const pagination = {
      pageSize,
      pageNum: 1
    };
    get('/information/pageUmsInformation', { title: '', ...pagination })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const getList = (obj = {}) => {
    const pagination = {
      pageSize,
      pageNum,
      ...obj
    };
    get('/information/pageUmsInformation', { title, ...pagination })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const add = () => {
    formRef.current = {};
    setDefaultFileList([]);
    setPicture([]);
    setVisible(true);
  };
  const del = (record: Item) => {
    get('/information/deleteInformation', { id: record.id })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          if (dataList.length > 1) {
            getList();
          } else {
            setPageNum(pageNum - 1);
          }
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const edit = (record: Item) => {
    formRef.current = record;
    form.setFieldsValue(record);
    const list = record.picture.map((url, i) => ({
      uid: `${i}`,
      name: `${i}`,
      url
    }));
    setPicture(record.picture);
    setDefaultFileList(list);
    setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    setDefaultFileList([]);
    form.resetFields();
  };
  const onOk = () => {
    const { title, content } = form.getFieldsValue();
    if (!title) {
      Message.error('请输入标题!');
      return;
    }
    if (!content) {
      Message.error('请输入正文!');
      return;
    }
    if (!picture.length) {
      Message.error('请上传图片!');
      return;
    }

    const data = {
      ...formRef.current,
      title,
      content,
      picture
    };
    const url = formRef.current.id ? '/information/editInformation' : '/information/saveInformation';
    post(url, data)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
          editCancel();
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const uploadChange = (fileList: any[]) => {
    const list = fileList.map(item => item.url || item.response?.data || '');
    setPicture(list);
  };

  useEffect(() => {
    getList();
  }, [pageNum]);

  return (
    <div className="composition table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <div className="filter-item">
          <Typography.Text>标题:</Typography.Text>
          <Input value={title} onChange={titleChange} style={{ width: 190 }} allowClear />
        </div>
        <Button
          className="filter-item"
          type="primary"
          onClick={() => {
            getList({ pageNum: 1 });
          }}
        >
          查询
        </Button>
        <Button className="filter-item" type="outline" onClick={handleReset}>
          重置
        </Button>
        <Button className="filter-item" type="primary" onClick={add}>
          新增
        </Button>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: false,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: num => {
              setPageNum(num);
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑' : '新增'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="标题" field="title">
            <Input placeholder="" />
          </FormItem>
          <FormItem label="正文" field="content">
            <TextArea placeholder="" />
          </FormItem>
          <FormItem label="图片">
            <Upload
              multiple
              imagePreview
              defaultFileList={defaultFileList}
              action={API_CONFIG.uploadUrl}
              onChange={uploadChange}
            />
          </FormItem>
        </Form>
      </Modal>
      <Modal
        title="视频"
        visible={videoVisible}
        onCancel={videoCancel}
        autoFocus={false}
        focusLock={true}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <video style={{ marginRight: 8 }} width={500} height={500} src={videoSrc} controls autoPlay />
      </Modal>
    </div>
  );
}

export default Composition;
